module.exports = __webpack_public_path__ + "static/media/sense4006.3bee17d4.jpg";